@if (isLoading()) {
    <app-loading />
} @else {
    @for (deposit of deposits(); track deposit.id) {
        <div class="bg-custom-light-grey m-2 rounded-lg">
            <app-expansion-panel [isExpanded]="deposits()!.length <= 1">
                <div
                    class="w-full"
                    header
                    (click)="toggleDepositSelected(deposit)">
                    <app-selectable-header
                        [checked]="addLayerService.selectedDeposit() === deposit.id"
                        [label]="`${deposit.version} - ${deposit.name}`"
                        [radioClass]="'ml-2 mb-2 mr-4'"
                        (selected)="toggleDepositSelected(deposit)" />
                </div>

                <div
                    class="w-11/12 m-auto"
                    content>
                    <p>{{ 'description' | transloco }}</p>
                    <div class="min-h-0 flex-1 overflow-x-auto">
                        <p class="text-custom-dark-grey text-sm font-normal">
                            {{ deposit.metadata?.['description'] }}
                        </p>
                    </div>
                </div>
            </app-expansion-panel>
        </div>
    } @empty {
        <app-no-data-to-display [displayedMessage]="'noDepositInData'" />
    }
}
